export const wrapWithContext = fn => (...args) => (
  dispatch,
  getState,
  { withContext },
) => withContext(fn)(...args);
